import { render } from "./WOCategoryList.vue?vue&type=template&id=400181b6&scoped=true"
import script from "./WOCategoryList.vue?vue&type=script&lang=js"
export * from "./WOCategoryList.vue?vue&type=script&lang=js"

import "./WOCategoryList.vue?vue&type=style&index=0&id=400181b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400181b6"]])

export default __exports__